import React from "react";
import { ExternalProviderMenuApi } from "../../../../../../../../../../../../services/Api/Organization/types";
import MenuExternalPortalMenuCategory from "./MenuExternalPortalMenuCategory";

interface Props {
	menu: ExternalProviderMenuApi[] | undefined;
}

const MenuExternalPortalMenu = ({ menu }: Props) => {
	if (!menu) return <></>;

	return (
		<table>
			<tbody className="external-provider-menu-list-body">
				{menu.map((item, index) => (
					<MenuExternalPortalMenuCategory category={item} key={index} />
				))}
			</tbody>
		</table>
	);
};

export default MenuExternalPortalMenu;
